import type { SVGProps } from 'react';
export const AlignmentRight = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M12.88 5c.34 0 .62.3.62.65v8.7c0 .36-.28.65-.62.65a.64.64 0 0 1-.62-.65v-8.7c0-.36.28-.65.62-.65M9.96 8.47c.2-.1.45-.1.63.04l1.32.95q.26.2.27.54 0 .35-.27.54l-1.31.95a.6.6 0 0 1-.64.04.7.7 0 0 1-.33-.58v-.3H7.12A.64.64 0 0 1 6.5 10c0-.36.28-.65.62-.65h2.5v-.3c0-.24.14-.46.34-.58"
      clipRule="evenodd"
    />
  </svg>
);
